import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

import { StickyCallToAction } from '../sticky-call-to-action/sticky-call-to-action'
import { useRedirect } from '../../services/router'
import { routes } from '../../routes'
import { withErrorBoundary } from '../error/with-error-boundary'
import { TrackedEvent, trackingService } from '../../services/tracking-service'

export const RaisedDisputesPanel = withErrorBoundary(({ raisedDisputesCount }: { raisedDisputesCount: number }) => {
  const redirect = useRedirect()
  const { t } = useTranslation()

  useEffect(() => {
    trackingService.track(TrackedEvent.StickyPanelRaisedDisputesShown)
  }, [])

  return (
    <section style={{ position: 'absolute', zIndex: 99 }}>
      <StickyCallToAction
        actionTitle={t('raised_disputes_panel.title')}
        actionSubtitle={t('raised_disputes_panel.n_disputes', { count: raisedDisputesCount })}
        action={() => {
          trackingService.track(TrackedEvent.StickyPanelRaisedDisputesClicked)
          redirect(routes.disputes, {})
        }}
        buttonTitle={t('raised_disputes_panel.review_now')}
        buttonStyle={{ background: '#D92D20' }}
      />
    </section>
  )
})
